import React, { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CaretUpDown, Buildings, Plus, Check } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function CompanySwitcher() {
  const { company, refreshCompany } = useAuth();
  const [open, setOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const ref = useRef();

  useEffect(() => {
    api.get("/agency/companies").then((r) => setCompanies(r.data)).catch(() => {});
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [company?.id]);

  const switchTo = async (id) => {
    await api.post(`/agency/switch/${id}`);
    await refreshCompany();
    setOpen(false);
    window.location.reload();
  };

  if (!company) return null;
  const showSwitcher = companies.length > 1;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => showSwitcher && setOpen(!open)}
        className={"w-full text-left px-5 py-4 border-b border-neutral-200 " +
                   (showSwitcher ? "hover:bg-neutral-50 transition-colors" : "cursor-default")}
        data-testid="company-switcher"
      >
        <div className="text-[10px] uppercase tracking-wider text-neutral-500 font-semibold flex items-center justify-between">
          <span>Active Company</span>
          {showSwitcher && <CaretUpDown size={12} />}
        </div>
        <div className="font-semibold text-sm mt-1 truncate">{company.name}</div>
        <div className="font-mono text-[11px] text-neutral-500">{company.gstin || company.country || "—"}</div>
      </button>

      {open && showSwitcher && (
        <div className="absolute z-50 top-full left-0 right-0 bg-white border border-neutral-300 shadow-lg max-h-96 overflow-y-auto"
             data-testid="switcher-dropdown">
          <div className="px-3 py-2 text-[10px] uppercase tracking-widest text-neutral-500 font-semibold border-b border-neutral-200">
            {companies.length} companies
          </div>
          {companies.map((c) => (
            <button key={c.id} onClick={() => switchTo(c.id)}
                    className="w-full text-left px-3 py-2.5 hover:bg-neutral-50 border-b border-neutral-100 flex items-start gap-2"
                    data-testid={`switch-to-${c.name}`}>
              <Buildings size={14} className="text-neutral-400 mt-0.5 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{c.name}</div>
                <div className="font-mono text-[10px] text-neutral-500">{c.gstin || "—"} · {c.state}</div>
              </div>
              {c.id === company.id && <Check size={14} className="text-emerald-600 shrink-0" />}
            </button>
          ))}
          <Link to="/app/agency" onClick={() => setOpen(false)}
                className="block px-3 py-2.5 text-sm font-semibold hover:bg-neutral-50 border-t border-neutral-200">
            <span className="flex items-center gap-2">
              <Plus size={14} /> Portfolio view
            </span>
          </Link>
        </div>
      )}
    </div>
  );
}
